import axios from "axios";
import { handleAxiosErrors, getRessource } from "../utils";

const ELIG = "/eligibilitepro";
const GET_ELIGIBILITE_PRO_SIRET_ZONE = `${ELIG}/get-siret-zone`;
const GET_ELIGIBILITE_PRO_MUX = `${ELIG}/get-eligibilitepro-mux`;
const GET_ELIGIBILITE_PRO_SIRET_MUX = `${ELIG}/get-eligibilitepro-siret-mux`;

export const getSiretZone = (minLng, minLat, maxLng, maxLat, abort) =>
  axios
    .get(GET_ELIGIBILITE_PRO_SIRET_ZONE, {
      signal: abort.signal,
      params: {
        minLng,
        minLat,
        maxLng,
        maxLat,
      },
    })
    .then(response => handleAxiosErrors(response))
    .then(url => getRessource(url, abort))
    .catch(error => Promise.reject(error));

export const getEligibiliteProMux = (lat, long, abort) =>
  axios
    .get(GET_ELIGIBILITE_PRO_MUX, {
      signal: abort.signal,
      params: {
        lat: lat,
        long: long,
      },
    })
    .then(response => handleAxiosErrors(response))
    .then(url => getRessource(url, abort))
    .catch(error => Promise.reject(error));

export const getEligibiliteProSiretMux = (siret, abort) =>
  axios
    .get(GET_ELIGIBILITE_PRO_SIRET_MUX, {
      signal: abort.signal,
      params: {
        siret: siret,
      },
    })
    .then(response => handleAxiosErrors(response))
    .then(url => getRessource(url, abort))
    .catch(error => Promise.reject(error));
